// removed by extract-text-webpack-plugin
module.exports = {"ChangeSchool":"ChangeSchool","ChangeSchool--manage":"ChangeSchool--manage","SchoolList":"SchoolList","SchoolList--item":"SchoolList--item","SchoolList--create":"SchoolList--create","SchoolList--item--confirm":"SchoolList--item--confirm","SchoolList--item--logo":"SchoolList--item--logo","SchoolList--item--name":"SchoolList--item--name","SchoolList--item--role":"SchoolList--item--role","SchoolList--item--remove":"SchoolList--item--remove","SchoolList--create--plus":"SchoolList--create--plus","SchoolList--create--price":"SchoolList--create--price"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/pages/ChangeSchool/ChangeSchool.scss
// module id = mRfb
// module chunks = 0